import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PatchNotificationView(incident, modifiedBy) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}notification?fields=incident&operator=eq&values=${incident}`;

    const response = await axios.get(req, apiConfig.HEADERS_CONFIG);

    // Crear un array para almacenar promesas de axios
    const patchPromises = [];

    for (const notification of response.data) {
      // Crear la URL para la petición PATCH
      let patchReq = `${apiConfig.BASE_URL}notification/${notification.notification1}`; // Asegúrate de que 'id' es la propiedad correcta
      
      // Datos a enviar en la petición PATCH
      const notificationPatch = {
        view : true,
        modifiedBy : modifiedBy
      }

      // Crear una nueva promesa para la petición PATCH y agregarla al array
      patchPromises.push(
        axios.patch(patchReq, notificationPatch, apiConfig.HEADERS_CONFIG)
      );
    }
    
    // Esperar que todas las promesas se resuelvan
    await Promise.all(patchPromises);

    // Devolver la respuesta original si es necesario
    return response.data;

  } catch (error) {
    // Manejar el error
    throw error;
  }
}


